export interface Movie {
  id: string;
  title: string;
  titleEn: string;
  category: string;
  categorySlug: string;
  year: number;
  rating: number;
  description: string;
  longDescription: string;
  director: string;
  cast: string[];
  genre: string[];
  region: string;
  duration: string;
  releaseDate: string;
  updateDate: string;
  coverImage: string;
  posterImage: string;
  isHot: boolean;
  isNew: boolean;
  isVip: boolean;
  episodeCount: string;
}

export const categories = [
  { name: '全部', slug: 'all', icon: 'ri-movie-line' },
  { name: '动作片', slug: 'action', icon: 'ri-fire-line' },
  { name: '喜剧片', slug: 'comedy', icon: 'ri-emotion-laugh-line' },
  { name: '爱情片', slug: 'romance', icon: 'ri-heart-line' },
  { name: '科幻片', slug: 'scifi', icon: 'ri-rocket-line' },
  { name: '恐怖片', slug: 'horror', icon: 'ri-ghost-line' },
  { name: '动画片', slug: 'animation', icon: 'ri-mickey-line' },
  { name: '剧情片', slug: 'drama', icon: 'ri-film-line' },
  { name: '悬疑片', slug: 'thriller', icon: 'ri-search-eye-line' },
  { name: '战争片', slug: 'war', icon: 'ri-sword-line' },
  { name: '纪录片', slug: 'documentary', icon: 'ri-camera-line' },
  { name: '电视剧', slug: 'tvseries', icon: 'ri-tv-line' },
];

export const allMovies: Movie[] = [
  {
    id: 'movie-1',
    title: '流浪地球3',
    titleEn: 'The Wandering Earth 3',
    category: '科幻片',
    categorySlug: 'scifi',
    year: 2026,
    rating: 9.1,
    description: '太阳急速老化，持续膨胀，地球面临被吞没的灭顶之灾。人类再次启动行星发动机，前往4.2光年外的新家园。',
    longDescription: '在《流浪地球3》中，地球在宇宙中漂泊数年后，人类面临着前所未有的挑战。行星发动机出现大规模故障，地球偏离了预定轨道，即将与一颗未知行星发生碰撞。联合政府紧急召集全球顶尖科学家和工程师，展开一场与时间赛跑的救援行动。与此同时，隐藏在人类内部的势力也开始浮出水面，他们究竟在密谋什么？一场关乎全人类命运的终极对决即将上演。',
    director: '郭帆',
    cast: ['吴京', '刘德华', '李雪健', '沙溢', '宁理'],
    genre: ['科幻', '灾难', '冒险'],
    region: '中国大陆',
    duration: '148分钟',
    releaseDate: '2026-01-22',
    updateDate: '2026-08-01',
    coverImage: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20sci-fi%20movie%20poster%2C%20Earth%20drifting%20through%20space%20with%20massive%20engines%2C%20dramatic%20cosmic%20lighting%2C%20cinematic%20atmosphere%2C%20clean%20composition%20with%20space%20and%20planets%2C%20movie%20poster%20aesthetic%2C%20high%20contrast&width=400&height=560&seq=movie-cover-1&orientation=portrait',
    posterImage: 'https://readdy.ai/api/search-image?query=Cinematic%20wide%20banner%20of%20Chinese%20sci-fi%20movie%2C%20massive%20spaceship%20and%20Earth%20in%20deep%20space%2C%20dramatic%20orange%20and%20blue%20cosmic%20lighting%2C%20epic%20scale%2C%20movie%20theatrical%20banner%20style%2C%20dark%20atmosphere%20with%20bright%20highlights&width=1600&height=700&seq=movie-hero-1&orientation=landscape',
    isHot: true,
    isNew: true,
    isVip: false,
    episodeCount: '1集全',
  },
  {
    id: 'movie-2',
    title: '封神第二部：战火西岐',
    titleEn: 'Creation of the Gods II',
    category: '动作片',
    categorySlug: 'action',
    year: 2026,
    rating: 8.8,
    description: '殷商大军兵临城下，西岐保卫战一触即发。姜子牙率领众神迎战，一场关乎天下命运的史诗对决。',
    longDescription: '商朝末年，纣王暴虐无道，天下民不聊生。姬发率领西岐义军奋起反抗，姜子牙辅佐其左右。闻仲太师率领殷商大军压境，一场惊天动地的神魔大战在西岐城外展开。哪吒、杨戬、雷震子等众神各显神通，与妲己麾下的妖魔展开殊死搏斗。封神榜上的名字一个个被点亮，天命之人终将改写历史。',
    director: '乌尔善',
    cast: ['黄渤', '费翔', '李雪健', '于适', '陈牧驰'],
    genre: ['动作', '奇幻', '史诗'],
    region: '中国大陆',
    duration: '156分钟',
    releaseDate: '2026-06-18',
    updateDate: '2026-07-28',
    coverImage: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20fantasy%20movie%20poster%2C%20ancient%20Chinese%20warriors%20in%20battle%20armor%2C%20mythological%20creatures%2C%20dramatic%20golden%20and%20red%20lighting%2C%20cinematic%20composition%2C%20clean%20poster%20layout&width=400&height=560&seq=movie-cover-2&orientation=portrait',
    posterImage: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20mythological%20war%20banner%2C%20ancient%20warriors%20with%20spears%20and%20banners%2C%20dramatic%20sky%20with%20golden%20light%2C%20cinematic%20wide%20shot%2C%20dark%20moody%20atmosphere%2C%20epic%20scale&width=1600&height=700&seq=movie-hero-2&orientation=landscape',
    isHot: true,
    isNew: true,
    isVip: true,
    episodeCount: '1集全',
  },
  {
    id: 'movie-3',
    title: '热辣滚烫2',
    titleEn: 'YOLO 2',
    category: '喜剧片',
    categorySlug: 'comedy',
    year: 2026,
    rating: 8.5,
    description: '乐莹的拳击人生继续！从拳击新手到职业选手，她用拳头打出属于自己的精彩人生。',
    longDescription: '继上一部减重百斤震惊全国之后，乐莹已经成功转型为一名职业拳击手。这一次，她面临更大的挑战——参加全国女子拳击锦标赛。训练中，她结识了一群性格各异的队友，有退役的老将、有叛逆的天才少女、有追梦的单亲妈妈。她们一起训练、一起成长，在拳击台上挥洒汗水与热血。但比赛前夕，乐莹的旧伤复发，她能否站上擂台，完成自己的梦想？',
    director: '贾玲',
    cast: ['贾玲', '雷佳音', '张小斐', '杨紫', '沙溢'],
    genre: ['喜剧', '运动', '励志'],
    region: '中国大陆',
    duration: '132分钟',
    releaseDate: '2026-02-10',
    updateDate: '2026-07-15',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20comedy%20movie%20poster%20with%20female%20boxer%2C%20energetic%20and%20inspiring%20vibe%2C%20warm%20lighting%20with%20red%20boxing%20gloves%2C%20cinematic%20portrait%20style%2C%20clean%20composition&width=400&height=560&seq=movie-cover-3&orientation=portrait',
    posterImage: 'https://readdy.ai/api/search-image?query=Boxing%20gym%20cinematic%20wide%20banner%2C%20female%20boxer%20training%20with%20determination%2C%20warm%20golden%20hour%20light%20through%20windows%2C%20inspiring%20atmosphere%2C%20dark%20background%20with%20dramatic%20lighting&width=1600&height=700&seq=movie-hero-3&orientation=landscape',
    isHot: true,
    isNew: false,
    isVip: false,
    episodeCount: '1集全',
  },
  {
    id: 'movie-4',
    title: '消失的她2',
    titleEn: 'Lost in the Stars 2',
    category: '悬疑片',
    categorySlug: 'thriller',
    year: 2026,
    rating: 8.7,
    description: '一桩离奇失踪案牵扯出惊天秘密，真相远比想象更加黑暗。金牌律师与神秘女子联手探案。',
    longDescription: '东南亚某国，中国游客林薇在豪华度假村神秘失踪。当地警方认定为意外溺水，但林薇的丈夫何非坚信妻子还活着。他聘请了华裔金牌律师陈麦跨国调查。随着调查深入，一个涉及人口贩卖、器官交易的跨国犯罪网络逐渐浮出水面。每一个线索都指向更大的阴谋，每一个证人都在撒谎。当真相揭晓的那一刻，所有人都倒吸一口凉气。',
    director: '陈思诚',
    cast: ['朱一龙', '倪妮', '文咏珊', '杜江', '黄子琪'],
    genre: ['悬疑', '犯罪', '剧情'],
    region: '中国大陆',
    duration: '142分钟',
    releaseDate: '2026-04-05',
    updateDate: '2026-08-02',
    coverImage: 'https://readdy.ai/api/search-image?query=Mystery%20thriller%20Chinese%20movie%20poster%2C%20dark%20moody%20atmosphere%2C%20silhouette%20of%20woman%20in%20rain%2C%20neon%20reflections%2C%20noir%20cinematic%20style%2C%20clean%20composition&width=400&height=560&seq=movie-cover-4&orientation=portrait',
    posterImage: 'https://readdy.ai/api/search-image?query=Dark%20mystery%20thriller%20cinematic%20banner%2C%20rainy%20city%20street%20at%20night%20with%20neon%20signs%2C%20noir%20atmosphere%2C%20silhouetted%20figures%2C%20dramatic%20moody%20lighting%2C%20suspenseful%20vibe&width=1600&height=700&seq=movie-hero-4&orientation=landscape',
    isHot: false,
    isNew: true,
    isVip: true,
    episodeCount: '1集全',
  },
  {
    id: 'movie-5',
    title: '唐人街探案4',
    titleEn: 'Detective Chinatown 4',
    category: '喜剧片',
    categorySlug: 'comedy',
    year: 2026,
    rating: 8.3,
    description: '唐仁与秦风再度联手，前往伦敦破解连环命案，笑料与悬疑齐飞。',
    longDescription: '接到英国警方的邀请，唐仁和秦风飞往伦敦协助调查一桩连环杀人案。受害者都是华裔，死法各不相同，唯一的共同点是案发现场都留有一张扑克牌。在伦敦唐人街，他们遇到了形形色色的人物：神秘的古董商、热情的餐厅老板娘、古怪的街头艺人。随着调查深入，他们发现这起案件与百年前的开膛手杰克有着惊人的相似之处。',
    director: '陈思诚',
    cast: ['王宝强', '刘昊然', '肖央', '张子枫', '妻夫木聪'],
    genre: ['喜剧', '悬疑', '动作'],
    region: '中国大陆',
    duration: '138分钟',
    releaseDate: '2026-01-29',
    updateDate: '2026-06-20',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20comedy%20detective%20movie%20poster%2C%20two%20detectives%20in%20London%20street%2C%20humorous%20and%20mysterious%20vibe%2C%20warm%20tones%2C%20cinematic%20poster%20design%2C%20clean%20layout&width=400&height=560&seq=movie-cover-5&orientation=portrait',
    posterImage: 'https://readdy.ai/api/search-image?query=London%20Chinatown%20cinematic%20wide%20banner%2C%20colorful%20lanterns%20and%20red%20decorations%2C%20detective%20theme%2C%20warm%20vibrant%20night%20scene%2C%20dark%20background%20with%20bright%20accents&width=1600&height=700&seq=movie-hero-5&orientation=landscape',
    isHot: false,
    isNew: false,
    isVip: false,
    episodeCount: '1集全',
  },
  {
    id: 'movie-6',
    title: '哪吒之魔童闹海2',
    titleEn: 'Ne Zha 2',
    category: '动画片',
    categorySlug: 'animation',
    year: 2026,
    rating: 9.3,
    description: '哪吒与敖丙的冒险继续！天劫之后，两人魂魄未散，太乙真人以莲藕重塑其身，新的冒险即将开启。',
    longDescription: '天劫过后，哪吒和敖丙虽然肉身毁灭，但魂魄被太乙真人以七色宝莲保住。太乙真人穷尽毕生修为，用莲藕为两人重塑身体。然而复活后的两人发现，更大的危机正在逼近——被封印的上古妖兽蠢蠢欲动，而天庭之中也有不为人知的秘密。哪吒和敖丙必须再次联手，保护陈塘关的百姓，同时揭开天劫背后的真相。',
    director: '饺子',
    cast: ['吕艳婷', '囧森瑟夫', '瀚墨', '陈浩', '绿绮'],
    genre: ['动画', '奇幻', '动作'],
    region: '中国大陆',
    duration: '125分钟',
    releaseDate: '2026-08-01',
    updateDate: '2026-08-02',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20animation%20movie%20poster%2C%20mythological%20boy%20with%20fire%20wheels%20and%20red%20ribbon%2C%20vibrant%20fantasy%20colors%2C%20dynamic%20composition%2C%20epic%20anime%20style%2C%20clean%20poster%20layout&width=400&height=560&seq=movie-cover-6&orientation=portrait',
    posterImage: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20animation%20cinematic%20banner%2C%20mythological%20warriors%20flying%20above%20ancient%20Chinese%20city%2C%20vibrant%20red%20and%20gold%20colors%2C%20dynamic%20action%20scene%2C%20dark%20stormy%20sky&width=1600&height=700&seq=movie-hero-6&orientation=landscape',
    isHot: true,
    isNew: true,
    isVip: false,
    episodeCount: '1集全',
  },
  {
    id: 'movie-7',
    title: '前任5：英年早婚',
    titleEn: 'Ex-Files 5',
    category: '爱情片',
    categorySlug: 'romance',
    year: 2026,
    rating: 7.9,
    description: '孟云和余飞各自面对婚姻这道难题，在爱情与自由之间挣扎抉择。',
    longDescription: '孟云和女朋友林佳已经在一起三年了，结婚似乎是顺理成章的下一步。但孟云始终下不了决心，他害怕婚后的生活会失去自我。与此同时，他的好兄弟余飞也面临着同样的困境——女友怀孕了，结婚刻不容缓。两个男人在友情和爱情中互相鼓励、互相吐槽，经历了一系列啼笑皆非的婚前风波后，终于明白了婚姻的真谛。',
    director: '田羽生',
    cast: ['韩庚', '郑恺', '于文文', '曾梦雪', '罗米'],
    genre: ['爱情', '喜剧'],
    region: '中国大陆',
    duration: '118分钟',
    releaseDate: '2026-05-20',
    updateDate: '2026-07-30',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20romantic%20comedy%20movie%20poster%2C%20couple%20in%20wedding%20theme%2C%20warm%20pink%20and%20golden%20tones%2C%20romantic%20atmosphere%2C%20cinematic%20portrait%20style%2C%20clean%20composition&width=400&height=560&seq=movie-cover-7&orientation=portrait',
    posterImage: 'https://readdy.ai/api/search-image?query=Romantic%20wedding%20cinematic%20banner%2C%20beautiful%20wedding%20venue%20with%20flowers%20and%20warm%20lighting%2C%20romantic%20atmosphere%2C%20soft%20focus%20background%2C%20golden%20hour%20light&width=1600&height=700&seq=movie-hero-7&orientation=landscape',
    isHot: false,
    isNew: false,
    isVip: false,
    episodeCount: '1集全',
  },
  {
    id: 'movie-8',
    title: '志愿军：存亡之战',
    titleEn: 'The Volunteers: To the Death',
    category: '战争片',
    categorySlug: 'war',
    year: 2026,
    rating: 9.0,
    description: '铁原阻击战，志愿军以血肉之躯抵挡敌军钢铁洪流，谱写了一曲气壮山河的英雄赞歌。',
    longDescription: '1951年5月，抗美援朝战争第五次战役期间，志愿军第63军在铁原地区展开了惨烈的阻击战。面对装备精良、人数众多的联合国军，志愿军将士用血肉之躯筑起了一道钢铁防线。在长达13个昼夜的战斗中，他们以惊人的毅力和勇气，成功迟滞了敌军的进攻，为主力部队的战略转移赢得了宝贵时间。',
    director: '陈凯歌',
    cast: ['朱一龙', '张子枫', '辛柏青', '吴京', '韩东君'],
    genre: ['战争', '历史', '剧情'],
    region: '中国大陆',
    duration: '155分钟',
    releaseDate: '2026-07-01',
    updateDate: '2026-08-02',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20war%20movie%20poster%2C%20soldiers%20in%20battlefield%20with%20smoke%20and%20fire%2C%20heroic%20atmosphere%2C%20dramatic%20lighting%2C%20historical%20military%20uniforms%2C%20clean%20poster%20design&width=400&height=560&seq=movie-cover-8&orientation=portrait',
    posterImage: 'https://readdy.ai/api/search-image?query=Epic%20war%20battlefield%20cinematic%20banner%2C%20soldiers%20charging%20through%20smoke%20and%20explosions%2C%20dramatic%20orange%20and%20dark%20lighting%2C%20heroic%20atmosphere%2C%20large%20scale%20battle%20scene&width=1600&height=700&seq=movie-hero-8&orientation=landscape',
    isHot: true,
    isNew: true,
    isVip: false,
    episodeCount: '1集全',
  },
  {
    id: 'tv-1',
    title: '庆余年2',
    titleEn: 'Joy of Life 2',
    category: '电视剧',
    categorySlug: 'tvseries',
    year: 2026,
    rating: 9.2,
    description: '范闲假死归来，继续在南庆朝堂中周旋，揭开身世之谜的同时，也陷入了更大的权力旋涡。',
    longDescription: '范闲在北齐经历了九死一生后，以假死之计回到了南庆。他一方面要应对庆帝的猜忌和试探，另一方面要追查母亲叶轻眉死亡的真相。在这个过程中，他结识了更多志同道合的伙伴，也遇到了更加危险的对手。朝堂之上的暗流涌动，江湖之中的恩怨情仇，范闲必须在这盘大棋中找到自己的位置。',
    director: '孙皓',
    cast: ['张若昀', '李沁', '陈道明', '吴刚', '郭麒麟'],
    genre: ['古装', '权谋', '武侠'],
    region: '中国大陆',
    duration: '45分钟/集',
    releaseDate: '2026-03-15',
    updateDate: '2026-08-01',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20drama%20poster%2C%20ancient%20Chinese%20scholar%20in%20elegant%20robes%2C%20palace%20background%2C%20golden%20warm%20lighting%2C%20dramatic%20cinematic%20style%2C%20clean%20composition&width=400&height=560&seq=movie-cover-tv1&orientation=portrait',
    posterImage: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20palace%20cinematic%20banner%2C%20grand%20imperial%20court%20with%20golden%20decorations%2C%20dramatic%20lighting%2C%20historical%20drama%20atmosphere%2C%20dark%20moody%20tones&width=1600&height=700&seq=movie-hero-tv1&orientation=landscape',
    isHot: true,
    isNew: true,
    isVip: true,
    episodeCount: '36集全',
  },
  {
    id: 'tv-2',
    title: '狂飙2：暗流涌动',
    titleEn: 'The Knockout 2',
    category: '电视剧',
    categorySlug: 'tvseries',
    year: 2026,
    rating: 9.0,
    description: '扫黑除恶专项斗争持续推进，新的案件浮出水面，安欣再度出击。',
    longDescription: '京海市的扫黑除恶行动取得了阶段性胜利，但安欣深知，黑恶势力的根基远未被彻底铲除。一封匿名举报信将他的目光引向了一个隐藏更深的犯罪网络。这一次，对手更加狡猾，手段更加隐蔽。安欣和他的团队必须与时间赛跑，在犯罪分子毁灭证据之前，揭开这层黑幕。',
    director: '徐纪周',
    cast: ['张译', '张颂文', '李一桐', '张志坚', '吴刚'],
    genre: ['犯罪', '剧情', '悬疑'],
    region: '中国大陆',
    duration: '45分钟/集',
    releaseDate: '2026-06-10',
    updateDate: '2026-08-02',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20crime%20drama%20poster%2C%20police%20officer%20in%20dark%20alley%2C%20noir%20cinematic%20style%2C%20suspenseful%20atmosphere%2C%20cool%20dark%20tones%2C%20clean%20poster%20design&width=400&height=560&seq=movie-cover-tv2&orientation=portrait',
    posterImage: 'https://readdy.ai/api/search-image?query=Dark%20city%20night%20cinematic%20banner%2C%20police%20car%20with%20flashing%20lights%20in%20rain%2C%20crime%20drama%20atmosphere%2C%20moody%20noir%20lighting%2C%20suspenseful%20urban%20scene&width=1600&height=700&seq=movie-hero-tv2&orientation=landscape',
    isHot: true,
    isNew: false,
    isVip: true,
    episodeCount: '40集全',
  },
  {
    id: 'tv-3',
    title: '繁花2：海上花开',
    titleEn: 'Blossoms Shanghai 2',
    category: '电视剧',
    categorySlug: 'tvseries',
    year: 2026,
    rating: 8.9,
    description: '九十年代上海，阿宝的商海传奇继续。黄浦江畔，繁华背后暗藏杀机。',
    longDescription: '进入九十年代中期，阿宝在上海滩已经站稳了脚跟。但随着市场经济的深入发展，新的挑战接踵而至。外商的进入、股市的波动、房地产的崛起，每一个风口都意味着机遇和风险。阿宝和他的朋友们在时代的洪流中奋力前行，有人一夜暴富，有人倾家荡产。黄浦江畔的霓虹灯下，每个人都在书写自己的传奇。',
    director: '王家卫',
    cast: ['胡歌', '马伊琍', '唐嫣', '辛芷蕾', '游本昌'],
    genre: ['剧情', '年代', '商战'],
    region: '中国大陆',
    duration: '50分钟/集',
    releaseDate: '2026-04-20',
    updateDate: '2026-08-01',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20period%20drama%20poster%2C%201990s%20Shanghai%20elegant%20businessman%2C%20neon%20lights%20and%20vintage%20atmosphere%2C%20cinematic%20noir%20style%2C%20warm%20golden%20tones&width=400&height=560&seq=movie-cover-tv3&orientation=portrait',
    posterImage: 'https://readdy.ai/api/search-image?query=1990s%20Shanghai%20Bund%20cinematic%20banner%2C%20neon%20signs%20and%20vintage%20cars%2C%20golden%20hour%20light%20on%20river%2C%20nostalgic%20atmosphere%2C%20dark%20moody%20sky&width=1600&height=700&seq=movie-hero-tv3&orientation=landscape',
    isHot: false,
    isNew: true,
    isVip: true,
    episodeCount: '30集全',
  },
  {
    id: 'tv-4',
    title: '三体：黑暗森林',
    titleEn: 'Three-Body: Dark Forest',
    category: '科幻片',
    categorySlug: 'scifi',
    year: 2026,
    rating: 9.4,
    description: '面对三体人的入侵，人类启动了面壁计划。罗辑成为面壁者之一，开始了一段孤独而伟大的征程。',
    longDescription: '三体舰队正以光速的百分之一向地球驶来，预计400年后抵达。人类世界陷入恐慌。联合国启动了绝密的面壁计划——选定四位面壁者，赋予他们无上的权力来制定对抗三体人的战略。罗辑，一个普通的宇宙社会学教授，被莫名其妙地选为面壁者之一。他必须独自思考、独自决策，因为三体人唯一无法看透的就是人类的思维。',
    director: '杨磊',
    cast: ['张鲁一', '于和伟', '陈瑾', '王子文', '林永健'],
    genre: ['科幻', '剧情', '悬疑'],
    region: '中国大陆',
    duration: '55分钟/集',
    releaseDate: '2026-07-15',
    updateDate: '2026-08-02',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20TV%20series%20poster%2C%20cosmic%20universe%20with%20mysterious%20planet%2C%20dark%20deep%20space%20background%2C%20minimalist%20sci-fi%20design%2C%20dramatic%20atmosphere&width=400&height=560&seq=movie-cover-tv4&orientation=portrait',
    posterImage: 'https://readdy.ai/api/search-image?query=Deep%20space%20cosmic%20cinematic%20banner%2C%20distant%20galaxy%20and%20stars%2C%20mysterious%20dark%20universe%2C%20sci-fi%20atmosphere%2C%20minimalist%20cosmic%20design%2C%20dark%20background%20with%20subtle%20starlight&width=1600&height=700&seq=movie-hero-tv4&orientation=landscape',
    isHot: true,
    isNew: true,
    isVip: true,
    episodeCount: '30集全',
  },
];

export const siteInfo = {
  name: '7777影院',
  fullName: '77777777影院',
  slogan: '免费在线影院，海量高清资源',
  description: '7777影院是一个免费在线影院，提供电影网站级的海量资源，支持免费看剧、高清播放，每日更新速度快，视频平台功能全面。',
  founded: '2018',
  email: 'contact@7777cinema.com',
  phone: '400-7777-888',
  address: '北京市朝阳区影视产业园区A座',
  stats: {
    totalMovies: '50,000+',
    dailyVisitors: '200万+',
    updateFrequency: '每日更新',
    years: '8年运营',
  },
};